// ref: https://usehooks-ts.com/react-hook/use-isomorphic-layout-effect

import { useEffect, useLayoutEffect } from 'react';
import { IS_SERVER } from '@/constants/isServer';

export const useIsomorphicLayoutEffect = IS_SERVER ? useEffect : useLayoutEffect;
